<template>
  <div id="page">

    <div class="row topCardGrid" id="cards">
      <sp-card :valor="ativos.total_funcionarios" :sufix="$t('graficosEducacao.folha-pagamento-professores.cards.ativos-sufix')" classDesc="pull-right"
        :descricao="'Média Etária: '+ativos.media_idade +' anos'" :footerText="$t('graficosEducacao.folha-pagamento-professores.cards.ativos-rodape', {data_consulta: dataRef, valor: remuneracaoAtivos})"
        :tooltip="infoRegimeContratacao" :placement="'right'">
      </sp-card>
      <sp-card :valor="inativos.total_funcionarios" :sufix="$t('graficosEducacao.folha-pagamento-professores.cards.inativos-sufix')" classDesc="pull-right"
        :descricao="'Média Etária: '+inativos.media_idade +' anos'" :footerText="$t('graficosEducacao.folha-pagamento-professores.cards.ativos-rodape', {data_consulta: dataRef, valor: remuneracaoInativos})">
      </sp-card>
      <sp-card :valor="abonoPermanencia.total_funcionarios" :sufix="$t('graficosEducacao.folha-pagamento-professores.cards.abonados-sufix')" classDesc="pull-right"
        :descricao="'Média Etária: '+abonoPermanencia.media_idade+' anos'" :footerText="$t('graficosEducacao.folha-pagamento-professores.cards.abonados-rodape', {data_consulta : dataPagina})"></sp-card>
    </div>

    <div class="row">
      <div class="flex col md6 sm12">
        <sp-360-panel :title="$t('graficosEducacao.folha-pagamento-professores.painel.etariedade-professores.titulo')" :footerText="$t('rodape.fonteData', {fonte: fonte, data: dataRef})">
          <sp360-chart id="faixaEtaria" type="horizontal-bar" :data="faixaEtaria.data" :options="faixaEtaria.options"/>
        </sp-360-panel>
      </div>
      <div class="flex col md6 sm12">
        <sp-360-panel :title="$t('graficosEducacao.folha-pagamento-professores.painel.raca-sexo.titulo')" :footerText="$t('rodape.fonteData', {fonte: fonte, data: dataRef})">
          <sp360-chart id="chartRacaSexo" type="vertical-bar" :data="dataRacaSexo" :options="optionsRacaSexo"/>
        </sp-360-panel>
      </div>
    </div>
    <div class="row">
      <div class="flex col md12 sm12">
        <sp-360-panel :title="$t('graficosEducacao.folha-pagamento-professores.painel.num-prof-categoria-cargo.titulo')" :footerText="$t('rodape.fonteData', {fonte: fonte, data: dataRef})">
           <sp360-chart id="folhaBar" type="vertical-bar" :data="dataNumProfCatCargo" :options="optionsNumProfCatCargo" />
        </sp-360-panel>
      </div>
    </div>
    <div class="row">
      <div class="flex col md12 sm12">
        <sp-360-panel :title="$t('graficosEducacao.folha-pagamento-professores.painel.categoria-cargo.titulo')" :footerText="$t('rodape.fonteData', {fonte: fonte, data: dataRef})">
          <va-tabs class="tabPadding" v-model="showTableCatCargo">
            <va-tab v-for="option in showTableCatCargoOptions" :key="option.atributo">
              {{ option.label }}
            </va-tab>
          </va-tabs>
          <div v-show="!showTableCatCargo">
            <sp360-chart id="folhaBar" type="vertical-bar" :data="dataCatCargo" :options="optionsCatCargo"
              v-show="toggle==='bar'" />
          </div>
          <div v-show="showTableCatCargo">
            <sp360-data-table v-show="showTableCatCargo" id="tabelaCatCargo" ref="tabelaCatCargo"
              :apiMode="false" :data="tabelaCatCargo.data" :fields="tabelaCatCargo.fields"
              :perPage="itemsPerPage" :onEachSide="1" :sortFunctions="tabelaCatCargo.sortFunctions" />
          </div>
        </sp-360-panel>
      </div>
    </div>
  </div>
</template>

<script>
import CorUtils from '@/utils/CorUtils'
import MethGlob from '@/utils/MetodosGlobais'
import _ from 'lodash'
import SpCard from '@/components/ui/cards/SP360Card'
import * as d3 from 'd3'
import * as legend from 'd3-svg-legend'
import ChartAnnotation from 'chartjs-plugin-annotation'
import Sp360Chart from '@/components/ui/chart/sp360chart'
import Sp360List from '@/components/ui/list/VaList'
import Sp360Panel from '@/components/ui/sp360-panel/sp360-panel'
import Sp360DataTable from '@/components/ui/dataTable/sp360datatable'
import Legenda from '@/components/maps/360-maps/Legenda'

export default {
  name: 'educacao-ativo-inativo-professores',
  mixins: [Legenda],
  components: {
    SpCard,
    Sp360Chart,
    Sp360Panel,
    Sp360DataTable,
    Sp360List,
  },

  data () {
    return {
      dataConsulta: null,
      ativos: 0,
      inativos: 0,
      abonoPermanencia: 0,
      comissionados: 0,
      fonte: '',
      dataRef: '',
      infoRegimeContratacao: '',

      dataRacaSexo: {},
      optionsRacaSexo: {},

      dataRegimeContratacao: {},
      optionsRegimeContratacao: {},

      dataCatCargo: {},
      optionsCatCargo: {},

      dataNumProfCatCargo: {},
      optionsNumProfCatCargo: {},

      toggle: 'bar',

      camposFaixaEtaria: ['X0_17', 'X18_24', 'X25_34', 'X35_44', 'X45_54', 'X55_64', 'X65_74', 'X75_mais'],
      faixaEtaria: {
        data: {},
        options: {},
      },
      datasetFaixaEtaria: [],

      showTableCatCargoOptions: [
        {
          atributo: 0,
          label: 'Gráfico',
        },
        {
          atributo: 1,
          label: 'Tabela',
        },
      ],
      showTableCatCargo: 0,
      showTablePerCapita: 0,

      itemsPerPage: 12,

      tabelaCatCargo: {
        data: [],
        sortFunctions: {
          'cargo': MethGlob.ordenaTabela,
          'total_pessoas': MethGlob.ordenaTabelaParseInt,
          'remuneracao_total_bruta': MethGlob.ordenaTabelaParseFloat,
          'media_remuneracao_total_bruta': MethGlob.ordenaTabelaParseFloat,
        },
        fields: [
          {
            name: 'cargo',
            sortField: 'cargo',
            title: this.$t('graficosEducacao.folha-pagamento-professores.painel.categoria-cargo.tabela.cargo'),
          },
          {
            name: 'total_pessoas',
            sortField: 'total_pessoas',
            title: this.$t('graficosEducacao.folha-pagamento-professores.painel.categoria-cargo.tabela.total-pessoas'),
            callback: function (value) { return MethGlob.formatarGrandesNumeros(value) },
            width: '14%',
          },
          {
            name: 'remuneracao_total_bruta',
            sortField: 'remuneracao_total_bruta',
            title: this.$t('graficosEducacao.folha-pagamento-professores.painel.categoria-cargo.tabela.remuneracao-total-bruta'),
            callback: function (value) { return 'R$' + MethGlob.formatarGrandesNumeros(value) },
            width: '15%',
          },
          {
            name: 'media_remuneracao_total_bruta',
            sortField: 'media_remuneracao_total_bruta',
            title: this.$t('graficosEducacao.folha-pagamento-professores.painel.categoria-cargo.tabela.media-remuneracao-total-bruta'),
            callback: function (value) { return 'R$' + MethGlob.formatarGrandesNumeros(value) },
            width: '16%',
          },
        ],
      },
      cores: [],
      termo: null,
    }
  },

  computed: {
    remuneracaoAtivos () { return this.ativos ? this.ativos.remuneracao_bruta.toLocaleString('pt-BR') : 0 },
    remuneracaoInativos () { return this.inativos ? this.inativos.remuneracao_bruta.toLocaleString('pt-BR') : 0 },
    dataPagina () { return this.dataConsulta ? this.dataConsulta.toLocaleDateString('pt-BR') : new Date().toLocaleDateString('pt-BR') },
  },

  created () {
    Promise.all([
      this.$store.dispatch('funcionalismo/buscarFolhaPagamentoProfessoresConsolidadoPorTipoRegime', {}),
      this.$store.dispatch('funcionalismo/buscarFolhaPagamentoProfessoresPorRegimeDeContratacao', {}),
      this.$store.dispatch('funcionalismo/buscarFolhaPagamentoProfessoresConsolidadoPorCargo', {}),
      this.$store.dispatch('funcionalismo/buscarFolhaPagamentoProfessoresPorFaixaEtariaServidores', {}),
      this.$store.dispatch('funcionalismo/buscarFolhaPagamentoProfessoresConsolidadoPorRacaSexo', {}),
    ]).then(respostas => {
      this.fonte = respostas[0].data.sigla_orgao + '-' + respostas[0].data.fonte
      this.dataRef = new Date(respostas[0].data.data_referencia_dado).toLocaleDateString('pt-BR')
      this.ref = this.$t('rodape.fonteData', { fonte: this.fonte, data: this.dataRef })

      this.cores = _.shuffle(CorUtils.getVetorCoresPorTom('medio'))
      this.calcularCards(respostas[0].data.data)

      this.optionsRegimeContratacao = {
        responsive: true,
        tooltips: {
          callbacks: MethGlob.percentualLabelCallback(false, true, 'donut'),
        },
        layout: {
          padding: {
            left: 0,
            right: 0,
            top: 40,
            bottom: 40,
          },
        },
        plugins: {
          datalabels: {
            formatter: (value, ctx) => {
              let sum = 0
              let dataArr = ctx.chart.data.datasets[0].data
              dataArr.map(data => {
                sum += data
              })
              let percentage = MethGlob.formataPercentual(value * 100 / sum) + '\n ' + MethGlob.thousandSeparator(parseFloat(value))
              return percentage
            },
            // anchor: 'start',
            // align: 'midd',
            color: '#000',
            display: 'auto',
            font: {
              weight: 'bold',
            },
          },
        },
        legend: {
          position: 'left',
          labels: {
            usePointStyle: 'true',
          },
        },
      }

      this.infoRegimeContratacao = this.criarInformativoRegimeContratacao(respostas[1].data.data)

      this.populateTabelasFolhaPorCargo(respostas[2].data.data)
      this.optionsCatCargo = this.getchartOptions(this.$t('graficosEducacao.folha-pagamento-professores.painel.categoria-cargo.eixo-x'),
        this.$t('graficosEducacao.folha-pagamento-professores.painel.categoria-cargo.eixo-y'))
      this.dataCatCargo = this.montarGraficoPorCategoriaCargo(respostas[2].data.data, this.optionsCatCargo)

      this.optionsNumProfCatCargo = this.getchartOptions(this.$t('graficosEducacao.folha-pagamento-professores.painel.num-prof-categoria-cargo.eixo-x'),
        this.$t('graficosEducacao.folha-pagamento-professores.painel.num-prof-categoria-cargo.eixo-y'))
      this.dataNumProfCatCargo = this.montarGraficoPorCategoriaCargoNumProfessores(respostas[2].data.data, this.optionsNumProfCatCargo)

      this.faixaEtaria.options = this.getBarChartPiramideOptions(this.$t('graficosEducacao.folha-pagamento-professores.painel.etariedade-professores.eixo-x'), '', 'linear', this.$t('graficosEducacao.folha-pagamento-professores.painel.etariedade-professores.titulo-interno'))
      this.faixaEtaria.data = this.populateProfessoresFaixaEtaria(respostas[3].data.data)

      this.optionsRacaSexo = this.getchartOptions(this.$t('graficosEducacao.folha-pagamento-professores.painel.raca-sexo.eixo-x'), this.$t('graficosEducacao.folha-pagamento-professores.painel.raca-sexo.eixo-y'))
      this.dataRacaSexo = this.montarGraficoPorRacaCor(respostas[4].data.data, this.optionsRacaSexo)
    })
  },

  methods: {

    calcularCards (dados) {
      if (dados) {
        this.dataConsulta = new Date(dados[0].data_folha_pagamento)
        this.comissionados = dados[0]
        this.inativos = dados[1]
        this.ativos = dados[2]
        this.abonoPermanencia = dados[0]
        let folha = 0
        dados.forEach(e => {
          folha += Number.parseFloat(e.remuneracao_bruta)
        })
        this.totalFolha = MethGlob.formatarGrandesNumeros(folha)
        this.mediaIdade = this.ativos.media_idade
      }
    },

    criarInformativoRegimeContratacao (tiposRegime) {
      let texto = ''
      const mapa = { 'EM COMISSAO': 'Em Comissão', 'EFETIVO': 'Efetivo', 'ADMITIDO': 'Admitido', 'CONTR TEMPO DETERM': 'Contrato em Tempo Determinado' }
      tiposRegime.forEach(regime => {
        let formato = `<b>${mapa[regime.regime_contratacao] !== typeof 'undefined' ? mapa[regime.regime_contratacao] : regime.regime_contratacao}</b>: ${MethGlob.formatarGrandesNumeros(regime.total_pessoas)}<br>`
        texto += formato
      })
      return texto
    },

    montarGraficoPorCategoriaCargo (dados, options, campo) {
      let chartData = { datasets: [], labels: [] }
	    let dataset = []
      dataset[0] = {
        order: 2,
        backgroundColor: campo ? CorUtils.getCorPorNomeSp360('amarelo-claro') : CorUtils.getCorPorNomeSp360('verde-limao-medio'),
        borderColor: this.$store.getters.palette.transparent,
        data: [],

        datalabels: {
          color: CorUtils.getCorPorNomeSp360('preto-escuro'),
          formatter: (value) => 'R$' + MethGlob.formatarGrandesNumeros(value),
          anchor: 'middle',
          rotation: -90,
          align: 'end',
          display: 'true',
          font: {
            weight: 'bold',
          },
        },
      }
      let cor = CorUtils.getCorPorNomeSp360('azul-claro')
      dataset[1] = {
        order: 1,
        backgroundColor: cor,
        borderColor: cor,
        data: [],
        datalabels: {
          color: CorUtils.getCorPorNomeSp360('preto-escuro'),
          formatter: (value) => MethGlob.formatarGrandesNumeros(value),
          anchor: 'middle',
          rotation: 0,
          align: 'end',
          display: false,
          font: {
            weight: 'bold',
          },
        },
        type: 'line',
        yAxisID: 'LineAxis',
        fill: false,
      }

      if (!campo) campo = 'remuneracao_total_bruta'
      dados = _.orderBy(dados, campo, 'desc')
      dados = dados.slice(0, 20)
      let total = 0
      dados.forEach(element => {
        if (element) {
          let nome = MethGlob.abreviarCargos(element.cargo)
          chartData.labels.push(nome)
          dataset[0].data.push(element[campo])
          dataset[0].label = this.$t('graficosEducacao.folha-pagamento-professores.painel.categoria-cargo.eixo-x')
          total += element[campo] || 0
        }
      })

      let aux = 0
      dados.forEach(element => {
        aux += ((element[campo] / total) * 100)
        dataset[1].data.push(aux)
        dataset[1].label = 'Acumulado'
      })

      chartData.datasets.push(dataset[0])
      chartData.datasets.push(dataset[1])

      options.layout.padding.top = 30
      options.scales.yAxes[0].type = 'linear' // 'logarithmic'

      options.scales.yAxes.push({
        id: 'LineAxis',
        position: 'right',
        gridLines: {
          display: false,
        },
        scaleLabel: {
          display: true,
          labelString: this.$t('graficosEducacao.folha-pagamento-professores.painel.categoria-cargo.legenda-linha'),
        },
        ticks: {
          max: 100,
          callback: function (value, index, values) {
            return value + '%'
          },
        },
      })

      options.scales.yAxes[0].ticks.callback = function (value, index, values) { return 'R$' + MethGlob.formatarGrandesNumeros(value) }

      return chartData
    },

    montarGraficoPorCategoriaCargoNumProfessores (dados, options, campo) {
      let chartData = { datasets: [], labels: [] }
	    let dataset = []
      dataset[0] = {
        order: 2,
        backgroundColor: campo ? CorUtils.getCorPorNomeSp360('amarelo-claro') : CorUtils.getCorPorNomeSp360('azul-columbia-claro'),
        borderColor: this.$store.getters.palette.transparent,
        data: [],

        datalabels: {
          color: CorUtils.getCorPorNomeSp360('preto-escuro'),
          formatter: (value) => MethGlob.formatarGrandesNumeros(value),
          anchor: 'middle',
          rotation: -90,
          align: 'end',
          display: 'true',
          font: {
            weight: 'bold',
          },
        },
      }
      let cor = CorUtils.getCorPorNomeSp360('vermelho-claro')
      dataset[1] = {
        order: 1,
        backgroundColor: cor,
        borderColor: cor,
        data: [],
        datalabels: {
          color: CorUtils.getCorPorNomeSp360('preto-escuro'),
          formatter: (value) => MethGlob.formatarGrandesNumeros(value),
          anchor: 'middle',
          rotation: 0,
          align: 'end',
          display: false,
          font: {
            weight: 'bold',
          },
        },
        type: 'line',
        yAxisID: 'LineAxis',
        fill: false,
      }

      if (!campo) campo = 'total_pessoas'
      dados = _.orderBy(dados, campo, 'desc')
      dados = dados.slice(0, 20)
      let total = 0
      dados.forEach(element => {
        if (element) {
          let nome = MethGlob.abreviarCargos(element.cargo)
          chartData.labels.push(nome)
          dataset[0].data.push(element[campo])
          dataset[0].label = this.$t('graficosEducacao.folha-pagamento-professores.painel.num-prof-categoria-cargo.eixo-x')
          total += element[campo] || 0
        }
      })

      let aux = 0
      dados.forEach(element => {
        aux += ((element[campo] / total) * 100)
        dataset[1].data.push(aux)
        dataset[1].label = 'Acumulado'
      })

      chartData.datasets.push(dataset[0])
      chartData.datasets.push(dataset[1])

      options.layout.padding.top = 30
      options.scales.yAxes[0].type = 'linear' // 'logarithmic'

      options.scales.yAxes.push({
        id: 'LineAxis',
        position: 'right',
        gridLines: {
          display: false,
        },
        scaleLabel: {
          display: true,
          labelString: this.$t('graficosEducacao.folha-pagamento-professores.painel.num-prof-categoria-cargo.legenda-linha'),
        },
        ticks: {
          max: 100,
          callback: function (value, index, values) {
            return value + '%'
          },
        },
      })

      options.scales.yAxes[0].ticks.callback = function (value, index, values) { return MethGlob.formatarGrandesNumeros(value) }

      return chartData
    },

    montarGraficoPorRacaCor (dados, options) {
      let chartData = { datasets: [], labels: [] }
      let datasetM = {
        backgroundColor: CorUtils.getCorPorNomeSp360('amarelo-medio'),
        borderColor: this.$store.getters.palette.transparent,
        data: [],
        label: 'Masculino',
        datalabels: {
          color: CorUtils.getCorPorNomeSp360('preto-escuro'),
          formatter: (value) => MethGlob.formatarGrandesNumeros(value),
          anchor: 'start',
          rotation: -90,
          align: 'end',
          display: 'true',
          font: {
            weight: 'bold',
          },
        },
      }

      let datasetF = {
        backgroundColor: CorUtils.getCorPorNomeSp360('amarelo-bistre-medio'),
        borderColor: this.$store.getters.palette.transparent,
        label: 'Feminino',
        data: [],
        datalabels: {
          color: CorUtils.getCorPorNomeSp360('preto-escuro'),
          formatter: (value) => MethGlob.formatarGrandesNumeros(value),
          anchor: 'start',
          rotation: -90,
          align: 'end',
          display: 'true',
          font: {
            weight: 'bold',
          },
        },
      }
      let grupos_ordenados = {}
      dados = _.orderBy(dados, 'total', 'desc')
      dados.forEach(grupo => {
        if (typeof grupos_ordenados[grupo.raca] === 'undefined') { grupos_ordenados[grupo.raca] = {} }
        grupos_ordenados[grupo.raca][grupo.sexo] = grupo.total
      })

      chartData.labels = Object.keys(grupos_ordenados)
      Object.keys(grupos_ordenados).forEach(raca => {
        datasetF.data.push(grupos_ordenados[raca].F)
        datasetM.data.push(grupos_ordenados[raca].M)
      })

      chartData.datasets.push(datasetF)
      chartData.datasets.push(datasetM)

      return chartData
    },

    getBarChartPiramideOptions (xAxixLabel, yAxixLabel, tipo = 'linear', titulo = '') {
      return {
        title: {
          display: (titulo != null && titulo != 'undefined' && titulo != ''),
          text: titulo,
        },
        layout: {
          padding: {
            left: -20,
            right: 25,
            top: 25,
            bottom: 5,
          },
        },
        plugins: {
          datalabels: {
            clamp: true,
            anchor: 'center',
            align: 'end',
            formatter: function (value, context) {
              return MethGlob.thousandSeparator(value)
            },
            color: '#000',
            display: 'auto',
            font:{
              weight: 'bold',
            }
          },
        },
        tooltips: {
          mode: 'index',
          enabled: true,
          intersect: true,
          callbacks: {
            title: function (tooltipItems, data) {
              var title = ''
              var labels = data.labels
              var labelCount = labels ? labels.length : 0
              if (tooltipItems.length > 0) {
                var item = tooltipItems[0]
                if (item.label) {
                  title = item.label
                } else if (item.xLabel) {
                  title = item.xLabel
                } else if (labelCount > 0 && item.index < labelCount) {
                  title = labels[item.index]
                }
              }
              return title
            },
            label: function (tooltipItem, details) {
              let dataset = details.datasets[tooltipItem.datasetIndex]
              let currentValue = dataset.data[tooltipItem.index]
              currentValue = currentValue < 0 ? -currentValue : currentValue
              return dataset.label ? dataset.label + ': ' + currentValue.toLocaleString('pt-BR') : currentValue.toLocaleString('pt-BR')
            },
          },
        },
        responsive: true,
        legend: {
          position: 'bottom',
          display: true,
          labels: {
            fontColor: '#34495e',
            fontFamily: 'sans-serif',
            fontSize: 14,
            padding: 20,
            usePointStyle: true,
          },
        },
        scales: {
          offset: true,
          yAxes: [{
            stacked: true,
            barPercentage: 1.1,
            scaleLabel: {
              display: true,
              labelString: yAxixLabel,
            },
            ticks: {
              beginAtZero: true,
              autoSkip: true,
              maxTicksLimit: 15,
              padding: 25,
              callback: function (value, index, values) {
                if (!isNaN(value)) {
                  return MethGlob.formatarGrandesNumeros(value)
                } else {
                  return value
                }
              },
            },
          }],
          xAxes: [
            {
              stacked: false,
              type: 'linear',
              gridLines: {
                display: false,
              },
              scaleLabel: {
                display: true,
                labelString: xAxixLabel,
              },
              ticks: {
                beginAtZero: true,
                callback: function (value, index, values) {
                  return MethGlob.formatarGrandesNumeros(value < 0 ? -value : value)
                },
              },
            },
          ],
        },
      }
    },
    populateProfessoresFaixaEtaria (dadosFiltrados) {
      let backgroundColor = CorUtils.getVetorCoresPorTom('claro').slice(6)
      let chartData = { labels: [], datasets: [] }

      chartData.labels = this.camposFaixaEtaria

      let corFem = backgroundColor.shift()
      let corMasc = backgroundColor.shift()

      dadosFiltrados.forEach(datasetPorSexo => {
        let dataset = {
          data: new Array(chartData.labels.length).fill(0),
          label: datasetPorSexo.sexo === 'M' ? 'Masculino' : 'Feminino',
          backgroundColor: datasetPorSexo.sexo === 'M' ? corMasc : corFem,
          stack: 'Stack 0',
          borderColor: datasetPorSexo.sexo === 'M' ? corMasc : corFem,
          fill: false,
          datalabels: {
            color: CorUtils.getCorPorNomeSp360('preto-escuro'),
            formatter: (value) => {
              value = value < 0 ? -value : value
              value = value === 0 ? 0 : value
              return value.toLocaleString('pt-BR')
            },
            anchor: datasetPorSexo.sexo === 'M' ? 'start' : 'end',
            rotation: 0,
            align: datasetPorSexo.sexo === 'M' ? 'start' : 'end',
            offset: 1,
            font: {
              weight: 'bold',
            },
          },
        }

        chartData.labels.forEach(element => {
          let posicao = chartData.labels.indexOf(element)
          if (posicao != -1) { dataset.data[posicao] = Number(datasetPorSexo[element]) }
        })
        if (dataset.label === 'Masculino') {
          dataset.data = dataset.data.map((k) => -k)
        }

        chartData.datasets.push(dataset)
      })

      chartData.labels = chartData.labels.map(label => this.getLabelFaixa(label))

      return chartData
    },
    getLabelFaixa (faixa) {
      let aux = faixa.split('_')
      let min = aux[0].replace('X', '')
      return 'De ' + min + ' a ' + aux[1] + ' anos'
    },
    getchartOptions (xAxixLabel, yAxixLabel) {
      return {
        layout: {
          padding: {
            left: 0,
            right: 5,
            top: 25,
            bottom: 5,
          },
        },
        plugins: {
          datalabels: {
            font:{
              weight: 'bold'
            }
          },
        },
        tooltips: {
          mode: 'index',
          enabled: true,
          intersect: true,
          callbacks: {
            title: function (tooltipItems, data) {
              var title = ''
              var labels = data.labels
              var labelCount = labels ? labels.length : 0

              if (tooltipItems.length > 0) {
                var item = tooltipItems[0]
                if (item.label) {
                  title = item.label
                } else if (item.xLabel) {
                  title = item.xLabel
                } else if (labelCount > 0 && item.index < labelCount) {
                  title = labels[item.index]
                }
              }

              return title
            },
            label: function (tooltipItem, details) {
              if (details.datasets[tooltipItem.datasetIndex].label === 'Folha por Orgão' || details.datasets[tooltipItem.datasetIndex].label === 'Distribuição Per capita') {
                let dataset = details.datasets[tooltipItem.datasetIndex]
                let currentValue = dataset.data[tooltipItem.index]
                return dataset.label + ': ' + 'R$' + currentValue.toLocaleString('pt-BR')
              } else if (details.datasets[tooltipItem.datasetIndex].label === 'Acumulado') {
                let dataset = details.datasets[tooltipItem.datasetIndex]
                let currentValue = dataset.data[tooltipItem.index]
                return dataset.label + ': ' + MethGlob.formataPercentual(currentValue)
              } else {
                let dataset = details.datasets[tooltipItem.datasetIndex]
                let currentValue = dataset.data[tooltipItem.index]
                return dataset.label ? dataset.label + ': ' + currentValue.toLocaleString('pt-BR') : currentValue.toLocaleString('pt-BR')
              }
            },
          },
        },
        responsive: true,
        legend: {
          position: 'bottom',
          display: true,
          labels: {
            fontColor: '#34495e',
            fontFamily: 'sans-serif',
            fontSize: 14,
            padding: 20,
            usePointStyle: true,
          },
        },
        scales: {
          yAxes: [{
            categoryPercentage: 0.2,
            barPercentage: 1.0,
            distribution: 'linear',

            scaleLabel: {
              display: true,
              labelString: yAxixLabel,
            },
            ticks: {
              beginAtZero: true,
              autoSkip: true,
              callback: function (value, index, values) {
                if (!isNaN(value)) {
                  return MethGlob.formatarGrandesNumeros(value)
                } else {
                  return value
                }
              },
            },
          }],
          xAxes: [
            {
              position: 'left',
              gridLines: {
                display: false,
              },
              scaleLabel: {
                display: true,
                labelString: xAxixLabel,
              },
              ticks: {
                callback: function (value, index, values) {
                  return value
                },
              },
            },
          ] },
      }
    },

    populateTabelasFolhaPorCargo (dados) {
      this.tabelaCatCargo.data = _.orderBy(dados, 'remuneracao_total_bruta', ['desc'])
    },
  },
}
</script>

<style lang='scss' scoped>
    .bubble{
        height:30rem;
        width:100%;
    }
    #folhaBar{
        height:40rem
    }
    #legenddiv {
        max-height: 10rem;
    }
    ::v-deep .red{
      background-color: #40e583;
    }
    #lista{
      max-height:  35rem;
      overflow-y: scroll;
    }
    #lista::-webkit-scrollbar {
        width: 12px;
    }
    #lista::-webkit-scrollbar-track {
        -webkit-box-shadow: inset 0 0 6px rgba(0,0,0,0.1);
        border-radius: 10px;
    }
    #lista::-webkit-scrollbar-thumb {
        border-radius: 10px;
        -webkit-box-shadow: inset 0 0 6px rgba(0,0,0,0.2);
    }
    #tabelaOrgao{
      padding:0;
    }
    .toprow{
      max-height: 30rem
    }
    #faixaEtaria{
      box-shadow: none;
      align-self: center;
      height:28rem
    }
    #chartRacaSexo {
      box-shadow: none;
      align-self: center;
      height:28rem
    }

</style>
